
import clsx from 'clsx'
import { PortableTextBlock } from 'next-sanity'

import { urlFor } from 'lib/sanity/image'

import MediaTextBlock from '../landings/MediaTextBlock'
import {
  SectionContainer,
  SectionContent,
  SectionContentPadding
} from '../landings/styles'

import styles from './MediaSection.module.scss'

type HeaderMarkColor = 'tertiary' | 'secondary'
interface MediaSectionProps {
  header: string
  headerMarkColor?: HeaderMarkColor
  content: PortableTextBlock
  imageSrc: string
  imageAlt: string
  imageSide: 'left' | 'right'
  top?: SectionContentPadding
  bottom?: SectionContentPadding
  topMobile?: SectionContentPadding
  bottomMobile?: SectionContentPadding
  cta?: {
    text: string
    link: string
  }
}

const MediaSection = ({
  header,
  content,
  imageSrc,
  imageAlt,
  imageSide,
  top = 24,
  bottom = 8,
  topMobile = 0,
  bottomMobile = 0,
  headerMarkColor,
  cta
}: MediaSectionProps) => {
  return (
    <SectionContainer $condensed>
      <SectionContent
        $top={top}
        $bottom={bottom}
        $topMobile={topMobile}
        $bottomMobile={bottomMobile}
      >
        <MediaTextBlock
          className={styles.mediaTextBlock}
          headerSize='3xl'
          header={
            <span
              className={clsx(styles.header, {
                [styles.headerTertiary]: headerMarkColor === 'tertiary'
              })}
              dangerouslySetInnerHTML={{
                __html: header
              }}
            />
          }
          content={content}
          imageSrc={urlFor(imageSrc).url()}
          imageAlt={imageAlt}
          imageSide={imageSide}
          mobileImageSide='bottom'
          srcIconList='/static/cancelation/xbox.svg'
          cta={
            cta && {
              text: cta.text,
              link: cta.link
            }
          }
        />
      </SectionContent>
    </SectionContainer>
  )
}

export default MediaSection
